import React, {useState, useEffect} from 'react';

const FieldHeight = ({value, onChange}) => {

  const [_value, setValue] = useState(value);

  useEffect(() => { onChange(_value); }, [_value]);

  return <div className="mb-3">
    <label htmlFor="height" className="form-label">Height</label>
    <input id="height"
           type="number"
           className="form-control"
           placeholder="Enter a height in pixels"
           min={1}
           value={_value || ''}
           onChange={e => setValue(e.target.value)} />
  </div>;
}

export default FieldHeight;